module.exports = __webpack_public_path__ + "img/canbadge-round-32mm-momo.bf4eece5.png";